import { ReactNode, useEffect, useState } from 'react'

export const useMaxWidth = (
  containerRef: React.MutableRefObject<HTMLDivElement>,
  correction: number = 0,
  children: ReactNode
) => {
  const [maxWidth, setMaxWidth] = useState<number>(undefined)

  useEffect(() => {
    if (!containerRef || !containerRef.current || maxWidth) return

    setMaxWidth(containerRef.current.parentElement.clientWidth)
    // eslint-disable-next-line
  }, [containerRef, children])

  return maxWidth ? maxWidth + correction : undefined
}
